class Tag {

  static find(key, value) {
    let json = localStorage.getItem(`tag:${key}:${value}`)
    if (!json) { return }

    return JSON.parse(json)
  }

  static set(key, value, json) {
    let string = JSON.stringify(json)
    localStorage.setItem(`tag:${key}:${value}`, string)
  }

}

export default Tag
